module.exports = __webpack_public_path__ + "img/icon_inst.83a9c951.svg";